import { getLocalStorageMenuItem, setLocalStorageMenuItem } from "./storage";
import sar_for_white_theme from "../images/sar_for_white_theme.svg";
import sar_for_dark_theme from "../images/sar_for_dark_theme.svg";

export const SetPrimaryBackgroundByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  return mode === "dark" ? "dark-mode-primary-background" : "primary-background";
};

export const SetSecondryBackgroundByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  return mode === "dark" ? "dark-mode-secandory-background" : "secondary-background";
};

export const SetThirdBackgroundByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  return mode === "dark" ? "dark-mode-third-background" : "gray-background";
};

export const SetPrimaryColorByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  return mode === "dark" ? "primary-color" : "dark-color";
};

export const SetSecondryColorByMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  return mode === "dark" ? "gray-color" : "secondary-color";
};

export const setMode = () => {
  const mode = getLocalStorageMenuItem("mode");
  return mode === "dark" ? "dark" : "light";
};

export const setMobileTextColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") return "#E0E1DD";
  if (theme === "light") return "#041731";
  if (theme === "costomize") return getLocalStorageMenuItem("textColor");
  return "#041731";
};

export const setMobileHighlightTextColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") return "#E0E1DD";
  if (theme === "light") return "#041731";
  if (theme === "costomize") return getLocalStorageMenuItem("textOnHighlights") || "#FFFFFF";
  return "#041731";
};

export const setMobileSubTextColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") return "#426CA5";
  if (theme === "light") return "#426CA5";
  if (theme === "costomize") return getLocalStorageMenuItem("textColor");
  return "#426CA5";
};

export const setMobileBackColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") return "#000205";
  if (theme === "light") return "#F2F4F7";
  if (theme === "costomize") return getLocalStorageMenuItem("backColor");
  return "#F2F4F7";
};

export const setMobileCardColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") return "#020E1D";
  if (theme === "light") return "#F0F6FE";
  if (theme === "costomize") return getLocalStorageMenuItem("cardColor");
  return "#F0F6FE";
};

export const setMobileCardBorderColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") return "#6BA5F2";
  if (theme === "light") return "#6BA5F2";
  if (theme === "costomize") return getLocalStorageMenuItem("highlights");
  return "#6BA5F2";
};

export const setMobileTextField_BK_FONT_Border_StyleColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") return ["#020E1D", "#E0E1DD", "#D0D5DD"];
  if (theme === "light") return ["#F9FAFB", "#98A2B3", "#D0D5DD"];
  if (theme === "costomize") {
    return [
      getLocalStorageMenuItem("cardColor"),
      getLocalStorageMenuItem("textColor"),
      "#D0D5DD",
    ];
  }
  return ["#f2f2f2", "#98A2B3"];
};

export const setMobileButttonBackColor = () => {
  const theme = getLocalStorageMenuItem("theme");
  if (theme === "dark") return "#6ba5f2";
  if (theme === "light") return "#6ba5f2";
  if (theme === "costomize") return getLocalStorageMenuItem("highlights");
  return "#6ba5f2";
};

export const setMobileSettings = (p_details) => {
  if (!getLocalStorageMenuItem("showOption")) {
    setLocalStorageMenuItem(
      "showOption",
      p_details.mobile_settings?.showOption
    );
  }
  if (p_details.mobile_settings?.theme === "costomize") {
    setLocalStorageMenuItem("theme", p_details.mobile_settings?.theme);
    setLocalStorageMenuItem("textColor", p_details.mobile_settings.colorProps.text);
    setLocalStorageMenuItem("backColor", p_details.mobile_settings.colorProps.back);
    setLocalStorageMenuItem("cardColor", p_details.mobile_settings.colorProps.card);
    setLocalStorageMenuItem("highlights", p_details.mobile_settings.colorProps.highlights);
    setLocalStorageMenuItem("textOnHighlights", p_details.mobile_settings.colorProps.textOnHighlights);
  } else {
    if (
      getLocalStorageMenuItem("theme") !== "dark" &&
      getLocalStorageMenuItem("theme") !== "light"
    ) {
      setLocalStorageMenuItem("theme", p_details.mobile_settings?.theme);
    }
  }
};

export const ISDARKTHEME = (theme, hexColor) => {
  if (theme === "dark") return true;
  if (theme === "light") return false;

  const hexToRgb = (hex) => {
    const bigint = parseInt(hex.replace("#", ""), 16);
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255,
    };
  };

  const calculateLuminance = (r, g, b) => {
    const adjust = (channel) => {
      let c = channel / 255;
      return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * adjust(r) + 0.7152 * adjust(g) + 0.0722 * adjust(b);
  };

  const { r, g, b } = hexToRgb(hexColor);
  const luminance = calculateLuminance(r, g, b);
  return luminance <= 0.5;
};

export const SARIconThemeColor = (reverse = false) => {
  const theme = getLocalStorageMenuItem("theme");

  if (ISDARKTHEME(theme, setMobileBackColor() || getLocalStorageMenuItem("tree_data")?.details?.mobile_settings?.colorProps?.back)) {
    return reverse ? sar_for_white_theme : sar_for_dark_theme;
  } else {
    return reverse ? sar_for_dark_theme : sar_for_white_theme;
  }
};

export const getBadgeStatusClass = (status_name) => {
  const theme_type = getLocalStorageMenuItem("theme");
  const isDark = theme_type === "dark";

  const statusMap = {
    "Excellent preparation on the table": isDark ? "excellent-badge-style-dark" : "excellent-badge-style",
    "Chef's Specialty": isDark ? "chef-badge-style-dark" : "chef-badge-style",
    "Most Ordered": isDark ? "mostordered-badge-style-dark" : "mostordered-badge-style",
    "Suitable for diabetic patients": isDark ? "suitable-badge-style-dark" : "suitable-badge-style",
    "Preferred for kids": isDark ? "new-badge-style-dark" : "new-badge-style",
    "Most ordered among BBQs": isDark ? "mostordered-badge-style-dark" : "mostordered-badge-style",
  };

  return statusMap[status_name] || (isDark ? "new-badge-style-dark" : "new-badge-style");
};

export const getOrderBadgeStatusClass = (status_name) => {
  const theme_type = getLocalStorageMenuItem("theme");
  const isDark = theme_type === "dark";

  const statusMap = {
    "cancelled": isDark ? "cancelled-badge-style-dark" : "cancelled-badge-style",
    "ready": isDark ? "ready-badge-style-dark" : "ready-badge-style",
    "completed": isDark ? "completed-badge-style-dark" : "completed-badge-style",
    "waiting": isDark ? "waiting-badge-style-dark" : "waiting-badge-style",
    "preparing": isDark ? "preparing-badge-style-dark" : "preparing-badge-style",
    "at delivery": isDark ? "at_delivery-badge-style-dark" : "at_delivery-badge-style",
  };

  return statusMap[status_name] || "";
};

export const getPopupBorderRaduis = () => "12px";
